import { S3Img } from '@/widgets/components/s3-img';
import { VerifiedIcon } from '@/widgets/components/verified-icon';
import styled, { css } from 'styled-components';

const CardWrapperStyle = css`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow:
    0 2px 3px 0 rgba(8, 10, 37, 0.03),
    0 4px 8.5px 0 rgba(8, 10, 37, 0.05),
    0 7.5px 35px 0 rgba(89, 126, 247, 0.03);
`;

export const CardWrapper = styled.div`
  cursor: pointer;
  ${CardWrapperStyle}
`;

export const BlurredCardWrapper = styled.div`
  filter: blur(0.33em);
  cursor: default;
  ${CardWrapperStyle}
`;

export const Header = styled.div<{ printMode: boolean }>`
  height: ${(props) => (props.printMode ? '150px' : '172px')};
  width: 100%;
  overflow: hidden;
`;

export const PropertyCardImage = styled(S3Img)`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  transition: transform 0.3s

  :hover {
    transform: scale(1.1);
  }
`;

export const PropertyCardBodyWrapper = styled.div<{ printMode: boolean }>`
  height: 116px;
  font-size: ${(props) => (props.printMode ? '9px' : '12px')};
  line-height: ${(props) => (props.printMode ? 1.2 : 1.67)};
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  margin-left: ${(props) => (props.printMode ? '17px' : '22px')};
  margin-right: ${(props) => (props.printMode ? '17px' : '22px')};
`;

export const Violations = styled.div`
  height: 22px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
`;

export const VerifiedPropertyIcon = styled(VerifiedIcon)`
  font-size: 20px;
  flex-shrink: 0;
`;

export const AddressWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  margin-top: 18px;

  height: 22px;
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.85);
`;

export const SummaryWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 8px;
  height: 22px;
`;

export const TextValue = styled.span`
  display: grid;
  place-items: center;

  height: 22px;
  font-size: 14px;
  line-height: 1.57;
  color: rgba(0, 0, 0, 0.85);
`;
